import { render, staticRenderFns } from "./ProformaTerms.vue?vue&type=template&id=41c06aeb&"
import script from "./ProformaTerms.vue?vue&type=script&lang=js&"
export * from "./ProformaTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports